import axios from 'axios'

var qs = require('qs');
var root=process.env.API_ROOT



//获取列表数据
export const getListData = (params) => {
  return axios.post(root+'/set/handlelog/list', qs.stringify(params))
}
//获取列表数据
export const getLogListData = (params) => {
  return axios.post(root+'/set/handlelog/list', qs.stringify(params))
}

//获取列表数据
export const saveData = (params) => {
  return axios.post(root+'/set/handlelog/save', qs.stringify(params))
}
//获取列表数据
export const bathsaveData = (params) => {
  return axios.post(root+'/set/handlelog/bathsave', qs.stringify(params))
}

//获取列表数据
export const updateData = (params) => {
  return axios.post(root+'/set/handlelog/update', qs.stringify(params))
}

//获取列表数据
export const remove = (params) => {
  return axios.post(root+'/set/handlelog/remove', qs.stringify(params))
}
//获取列表数据
export const logremove = (params) => {
  return axios.post(root+'/set/handlelog/logremove', qs.stringify(params))
}

export const lockremove = (params) => {
  return axios.post(root+'/set/handlelog/lockremove', qs.stringify(params))
}






// WEBPACK FOOTER //
// ./src/api/set/handlelog.js